import type { ParcelRow } from '@mollusk/shared';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useIsAdmin, visibleFields } from '../auth/internal';

const FIELDS: ReadonlyArray<keyof ParcelRow> = [
  'parcel_id',
  'source_id',
  'source_parcel_id',
  'parcel_id_normalized',
  'address_line1',
  'city',
  'jurisdiction_state',
  'postal_code',
  'owner_name',
  'land_use_normalized',
  'zoning',
  'year_built',
  'building_sqft',
  'units',
  'area_sqft',
  'assessed_total',
  'assessed_land',
  'assessed_improvement',
];

export function ParcelDetailModal({
  parcels,
  onClose,
}: {
  parcels: ParcelRow[];
  onClose: () => void;
}) {
  const isAdmin = useIsAdmin();
  const open = parcels.length > 0;
  const title = parcels.length <= 1 ? 'Parcel detail' : `Parcel records (${parcels.length})`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {parcels.map((parcel, i) => (
          <Box key={parcel.parcel_id} sx={{ mt: i === 0 ? 0 : 2 }}>
            {isAdmin && (parcel.parcel_id_normalized || parcel.address_line1) && (
              <Button
                href={`/planning-detail?q=${encodeURIComponent(parcel.parcel_id_normalized ?? parcel.address_line1 ?? '')}${parcel.jurisdiction_state ? `&state=${encodeURIComponent(parcel.jurisdiction_state)}` : ''}`}
                sx={{ mb: 1 }}
              >
                Planning cases for parcel
              </Button>
            )}
            {parcels.length > 1 ? (
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                {isAdmin ? parcel.source_id : `Record ${i + 1}`}
              </Typography>
            ) : null}
            <Table size="small">
              <TableBody>
                {visibleFields(FIELDS, isAdmin).map((field) => {
                  const v = parcel[field];
                  if (v === null || v === undefined || v === '') return null;
                  return (
                    <TableRow key={field}>
                      <TableCell sx={{ fontWeight: 600, width: 220 }}>{field}</TableCell>
                      <TableCell>{String(v)}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            {i < parcels.length - 1 ? <Divider sx={{ mt: 2 }} /> : null}
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
}
